// extracted by mini-css-extract-plugin
export default {"modalZ":"100001","headerHeight":"80px","root":"qQ_hX","tablet":"wjZfu","mobile":"P_BY4","smallMobile":"PwGWb","joinTango":"twIIn"};